import { URLS } from "@app/shared";
export * from "./gevernance-data";

export const investorBasicInfoBreadcrumb = [
  { label: "home", link: URLS.home },
  { label: "investorRelations", link: URLS.investor.root },
  { label: "basicInfo.title" },
];

export const investorSharePerformanceBreadcrumb = [
  { label: "home", link: URLS.home },
  { label: "investorRelations", link: URLS.investor.root },
  { label: "sharePerformance.title" },
];

export const investorGovernanceDocumentsBreadcrumb = [
  { label: "home", link: URLS.home },
  { label: "investorRelations", link: URLS.investor.root },
  { label: "governanceDocuments" },
];

export const dividendsAndShareholdersBreadcrumb = [
  { label: "home", link: URLS.home },
  { label: "investorRelations", link: URLS.investor.root },
  { label: "dividendsAndShareholders.title" },
];

export const sharePerformanceChartData = [
  {
    name: "annuly-chart",
    src: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTGFl6BmkEoGn5ntP-5ZK6Wq6AsJsYa-Zy7uFrJZdW0zY1ZgAty9Bbul_yHTZpeoz9lQKfAh13Kvf9Z/pubchart?oid=1455042671&format=interactive",
  },
  {
    name: "quarterly-chart",
    src: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTGFl6BmkEoGn5ntP-5ZK6Wq6AsJsYa-Zy7uFrJZdW0zY1ZgAty9Bbul_yHTZpeoz9lQKfAh13Kvf9Z/pubchart?oid=1533145188&format=interactive",
  },
  {
    name: "financial-annuly-chart",
    src: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTGFl6BmkEoGn5ntP-5ZK6Wq6AsJsYa-Zy7uFrJZdW0zY1ZgAty9Bbul_yHTZpeoz9lQKfAh13Kvf9Z/pubchart?oid=1758913083&format=interactive",
  },
  {
    name: "financial-quarterly-chart",
    src: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTGFl6BmkEoGn5ntP-5ZK6Wq6AsJsYa-Zy7uFrJZdW0zY1ZgAty9Bbul_yHTZpeoz9lQKfAh13Kvf9Z/pubchart?oid=97739318&format=interactive",
  },
  {
    name: "sales-geographic-area-chart",
    src: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTGFl6BmkEoGn5ntP-5ZK6Wq6AsJsYa-Zy7uFrJZdW0zY1ZgAty9Bbul_yHTZpeoz9lQKfAh13Kvf9Z/pubchart?oid=1324393706&format=interactive",
  },
  {
    name: "local-sales-exports-chart",
    src: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTGFl6BmkEoGn5ntP-5ZK6Wq6AsJsYa-Zy7uFrJZdW0zY1ZgAty9Bbul_yHTZpeoz9lQKfAh13Kvf9Z/pubchart?oid=1989980728&format=interactive",
  },
];

export const performanceHeader = [
  "durations",
  "highest",
  "lowest",
  "change",
  "startOfYears",
  "yearAgo",
  "threeYearsAgo",
];

export const performanceHeaderData = [
  {
    durations: "52 week",
    highest: "48.85",
    lowest: "24.12",
    change: "26.43",
    startOfYears: "32.45",
    yearAgo: "26.75",
    threeYearsAgo: "18.14",
  },
];

export const dividendsHeader = [
  "period",
  "dividendPerShare",
  "totalDividendsDistributed",
  "percentageOfCapital",
];

export const dividendsHeaderData = [
  {
    period: "07/2017 - 12/2017",
    dividendPerShare: "1.00",
    totalDividendsDistributed: { value: "60,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "01/2017 - 07/2017",
    dividendPerShare: "1.00",
    totalDividendsDistributed: { value: "60,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "01/2016 - 06/2016",
    dividendPerShare: "1.00",
    totalDividendsDistributed: { value: "60,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "07/2015 - 12/2015",
    dividendPerShare: "1.00",
    totalDividendsDistributed: { value: "60,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "01/2015 - 06/2015",
    dividendPerShare: "1.00",
    totalDividendsDistributed: { value: "60,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "07/2014 - 12/2014",
    dividendPerShare: "1.00",
    totalDividendsDistributed: { value: "60,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "01/2014 - 06/2014",
    dividendPerShare: "1.00",
    totalDividendsDistributed: { value: "60,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "07/2013 - 12/2013",
    dividendPerShare: "0.75",
    totalDividendsDistributed: { value: "60,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "01/2013 - 06/2013",
    dividendPerShare: "0.75",
    totalDividendsDistributed: { value: "45,000,000" },
    percentageOfCapital: { value: "7.50" },
  },
  {
    period: "07/2012 - 12/2012",
    dividendPerShare: "0.75",
    totalDividendsDistributed: { value: "45,000,000" },
    percentageOfCapital: { value: "7.50" },
  },

  {
    period: "01/2012 - 06/2012",
    dividendPerShare: "0.75",
    totalDividendsDistributed: { value: "45,000,000" },
    percentageOfCapital: { value: "7.50" },
  },
  {
    period: "07/2011 - 12/2011",
    dividendPerShare: "0.75",
    totalDividendsDistributed: { value: "45,000,000" },
    percentageOfCapital: { value: "7.50" },
  },
  {
    period: "01/2011 - 06/2011",
    dividendPerShare: "0.75",
    totalDividendsDistributed: { value: "45,000,000" },
    percentageOfCapital: { value: "7.50" },
  },
  {
    period: "07/2010 - 12/2010",
    dividendPerShare: "0.75",
    totalDividendsDistributed: { value: "45,000,000" },
    percentageOfCapital: { value: "7.50" },
  },
  {
    period: "01/2010 - 06/2010",
    dividendPerShare: "0.75",
    totalDividendsDistributed: { value: "45,000,000" },
    percentageOfCapital: { value: "7.50", note: 1 },
  },

  {
    period: "01/2009 - 12/2009",
    dividendPerShare: "1.50",
    totalDividendsDistributed: { value: "67,500,000" },
    percentageOfCapital: { value: "15.00" },
  },
  {
    period: "01/2008 - 12/2008",
    dividendPerShare: "1.50",
    totalDividendsDistributed: { value: "67,500,000" },
    percentageOfCapital: { value: "15.00" },
  },
  {
    period: "01/2007 - 12/2007",
    dividendPerShare: "1.50",
    totalDividendsDistributed: { value: "67,500,000" },
    percentageOfCapital: { value: "15.00" },
  },
  {
    period: "01/2006 - 12/2006",
    dividendPerShare: "1.50",
    totalDividendsDistributed: { value: "67,500,000" },
    percentageOfCapital: { value: "15.00" },
  },
  {
    period: "01/2005 - 12/2005",
    dividendPerShare: "000",
    totalDividendsDistributed: { value: "000", note: 2 },
    percentageOfCapital: { value: "000" },
  },
  {
    period: "01/2004 - 12/2004",
    dividendPerShare: "6.00",
    totalDividendsDistributed: { value: "42,000,000", note: 3 },
    percentageOfCapital: { value: "12.00" },
  },
  {
    period: "01/2003 - 12/2003",
    dividendPerShare: "3.00",
    totalDividendsDistributed: { value: "18,000,000" },
    percentageOfCapital: { value: "6.00" },
  },
  {
    period: "01/2002 - 12/2002",
    dividendPerShare: "6.00",
    totalDividendsDistributed: { value: "36,000,000" },
    percentageOfCapital: { value: "12.00" },
  },
  {
    period: "01/2001 - 12/2001",
    dividendPerShare: "5.00",
    totalDividendsDistributed: { value: "30,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
  {
    period: "01/2000 - 12/2000",
    dividendPerShare: "4.00",
    totalDividendsDistributed: { value: "24,000,000" },
    percentageOfCapital: { value: "8.00" },
  },

  {
    period: "07/1998 - 12/1999",
    dividendPerShare: "7.00",
    totalDividendsDistributed: { value: "42,000,000" },
    percentageOfCapital: { value: "14.00" },
  },
  {
    period: "01/1998 - 07/1999",
    dividendPerShare: "5.00",
    totalDividendsDistributed: { value: "30,000,000" },
    percentageOfCapital: { value: "10.00" },
  },
];

export const shareholdersHeader = [
  "shareholder",
  "type",
  "totalHoldingPercentage",
];

export const shareholdersHeaderData = [
  {
    shareholder: "dividendsAndShareholders.data.Zamil Group Holding Company",
    type: "institution",
    totalHoldingPercentage: "20",
  },
  {
    shareholder: "dividendsAndShareholders.data.Zamil Group Investment Company",
    type: "institution",
    totalHoldingPercentage: "5.153",
  },
];
